//Criterios con los que se decide que dos expedientes están relacionados. Espejo de
//RelatedCasesCriteria del backend: el valor activo se configura por empresa en Configuraciones
//(código CASES_DUPLICATE_CRITERIA) y lo resuelve el backend, aquí solo se interpreta la respuesta.
export enum RelatedCasesCriteria {
    Policy = 'POLICY',
    ClientAddress = 'CLIENT_ADDRESS'
}

export interface RelatedCases {
    criteria: RelatedCasesCriteria;
    count: number;
    caseIds: string[];
}
